import { gql } from 'graphql-tag';
import { useQuery } from '@apollo/client';

export const PREVIEW_BULK_UNASSIGN_TASKS_TO_RESOURCEUSER = gql`
  query previewBulkUnassignTasksToResourceUser(
    $input: BulkUnassignTasksToResourceUserInput!
  ) {
    previewBulkUnassignTasksToResourceUser(input: $input) {
      hasTaskResourceAllocation
    }
  }
`;

export const usePreviewBulkUnassignTasksToResourceUser = ({
  projectId,
  resourceUserId,
  textSearch
}) => {
  const { data, loading } = useQuery(
    PREVIEW_BULK_UNASSIGN_TASKS_TO_RESOURCEUSER,
    {
      variables: {
        input: {
          projectId,
          resourceUserId,
          textSearch
        }
      },
      fetchPolicy: 'cache-and-network'
    }
  );

  return {
    hasTaskResourceAllocation:
      data?.previewBulkUnassignTasksToResourceUser?.hasTaskResourceAllocation ||
      false,
    isLoading: loading
  };
};
